import React from 'react';
import { FaBox, FaBoxes, FaCashRegister, FaHome, FaMoneyCheckAlt, FaNotesMedical, FaPeopleCarry, FaSlidersH, FaUser } from "react-icons/fa";
import { FiCalendar, FiGrid, FiMessageCircle, FiRefreshCw, FiSettings, FiFileText, FiType, FiShoppingCart } from "react-icons/fi";
import { MdPersonSearch } from "react-icons/md";
import { IoDocumentText } from "react-icons/io5";

const iconMap = {
  dashboard: FaHome,
  staffUser: FaUser,
  chats: FiMessageCircle,
  calendar: FiCalendar,
  referral: FiRefreshCw,
  settings: FiSettings,
  file: FiFileText,
  sales: FaCashRegister,
  purchase: FaBox,
  stock: FaBoxes,
  medicine: FaNotesMedical,
  inventory: FaSlidersH,
  supplier: FaPeopleCarry,
  transaction: FaMoneyCheckAlt,
  search: MdPersonSearch,
  report: IoDocumentText
};

const IconRenderer = ({ iconName, className }) => {
  const IconComponent = iconMap[iconName];
  return IconComponent ? <IconComponent className={className} /> : null;
};

export default IconRenderer;
